import { createSlice } from '@reduxjs/toolkit'
import { loadStoredUser, saveStoredUser, clearStoredUser } from '../../../utils/authStorage'

export const login = createSlice({
  name: 'login',
  initialState: {
    // Hidratación síncrona: el rol queda disponible desde el primer render
    // al recargar, evitando el estado "no autenticado" intermedio.
    authenticated: loadStoredUser(),
    visible: false,
    username: null,
    requiresPasswordChange: false,
  },
  reducers: {
    verificated: (state, action) => {
      state.authenticated = action.payload
    },
    activated: (state, action) => {
      state.visible = action.payload
    },
    setUsername: (state, action) => {
      state.username = action.payload
    },
    setRequiresPasswordChange: (state, action) => {
      state.requiresPasswordChange = action.payload
    },
  },
})

export const { verificated, activated, setUsername, setRequiresPasswordChange } = login.actions

// Establece la sesión: persiste el usuario verificado y actualiza el estado.
export const setAuthSession = userLocal => dispatch => {
  saveStoredUser(userLocal)
  dispatch(verificated(userLocal))
}

// Limpia la sesión: borra token + usuario persistidos y resetea el estado.
// No navega; cada caller decide a dónde redirigir.
export const clearAuthSession = () => dispatch => {
  clearStoredUser()
  dispatch(verificated(null))
}

export default login.reducer
